import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  key: 1,
  class: "pt-4 px-8"
}
const _hoisted_2 = {
  class: "flex flex-col",
  style: {"height":"calc(100% - 20px)"}
}
const _hoisted_3 = {
  class: "flex flex-row items-center justify-between pt-3 border-b border-gray-lp-200",
  style: {"padding-left":"30px","padding-bottom":"15px"}
}
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_5 = { class: "flex items-center gap-4 h-6" }
const _hoisted_6 = { class: "text-xl font-bold text-black-lp-200" }
const _hoisted_7 = { class: "flex items-center gap-2 pl-10" }
const _hoisted_8 = { class: "text-gray-lp-300 text-12px flex gap-1" }
const _hoisted_9 = { class: "text-gray-lp-800 text-12px" }
const _hoisted_10 = {
  key: 1,
  class: "flex gap-2 w-full"
}
const _hoisted_11 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_12 = { class: "flex-grow px-6 pb-6 flex overflow-hidden" }
const _hoisted_13 = { class: "w-2/3 pr-4 pb-3" }
const _hoisted_14 = { class: "w-1/3 mt-6 pl-4 border-l" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_HistorySection = _resolveComponent("HistorySection")!
  const _component_SummarySection = _resolveComponent("SummarySection")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Breadcrumb, {
          key: 0,
          class: "pt-4 px-8 pusat-resolusi-v2-detail"
        }))
      : (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_Skeleton, {
            width: "140px",
            height: "14px"
          })
        ])),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (!_ctx.loading)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("img", {
                  src: _imports_0,
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                  class: "w-6 cursor-pointer",
                  alt: "back"
                }),
                _createVNode("h1", _hoisted_6, _toDisplayString(_ctx.ticketDetail.ticket.caseNumber) + " - " + _toDisplayString(_ctx.title), 1),
                _createVNode(_component_Chips, {
                  class: "my-2",
                  weight: "bold",
                  color: _ctx.currentStatus.bgColor,
                  textColor: _ctx.currentStatus.color,
                  label: _ctx.$t(_ctx.currentStatus.label),
                  rounded: "",
                  border: "",
                  borderColor: _ctx.currentStatus.borderColor,
                  textSize: 16,
                  textTransform: "normal-case"
                }, null, 8, ["color", "textColor", "label", "borderColor"])
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode("div", {
                  class: `${_ctx.currentPriority.bgColor} px-1 rounded`
                }, [
                  _createVNode("span", {
                    class: `${_ctx.currentPriority.color} text-14px font-medium`
                  }, _toDisplayString(_ctx.currentPriority.label), 3)
                ], 2),
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("pusatResolusi.detailPage.updated")), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.formatCreatedDate(_ctx.ticketDetail.ticket.updatedAt)), 1)
                ])
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_10, [
              _createVNode("img", {
                src: _imports_0,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                class: "w-5 mr-3 cursor-pointer",
                alt: "back"
              }),
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_Skeleton, { width: "80%" }),
                _createVNode(_component_Skeleton, { width: "50%" })
              ])
            ]))
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_HistorySection, {
            data: _ctx.ticketDetail,
            action: _ctx.ticketAction,
            detailId: _ctx.id,
            websocket: _ctx.websocket,
            onUpdateAction: _ctx.updateAction,
            onGetDetail: _ctx.getTicketDetail
          }, null, 8, ["data", "action", "detailId", "websocket", "onUpdateAction", "onGetDetail"])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode(_component_SummarySection, {
            errorState: _ctx.errorState,
            data: _ctx.ticketDetail,
            action: _ctx.ticketAction,
            isLoading: _ctx.loading,
            websocket: _ctx.websocket,
            onGetDetail: _ctx.getTicketDetail
          }, null, 8, ["errorState", "data", "action", "isLoading", "websocket", "onGetDetail"])
        ])
      ])
    ]),
    (_ctx.showWebsocketErrorModal)
      ? (_openBlock(), _createBlock(_component_Modal, _mergeProps({ key: 2 }, _ctx.websocketErrorModalEntities), {
          "custom-button": _withCtx(() => [
            _createVNode(_component_lp_button, {
              id: "button_retry_websocket_pusat_resolusi",
              title: _ctx.$t('pusatResolusi.modal.reload'),
              textColor: "white",
              color: "red-lp-100",
              fontWeight: "semibold",
              iconLeft: "refresh-white",
              isWidthFull: "",
              onClick: _ctx.reconnectWebsocket
            }, null, 8, ["title", "onClick"])
          ]),
          _: 1
        }, 16))
      : _createCommentVNode("", true)
  ], 64))
}